enum Languages {
    'pt-BR' = 0,
    'en-US' = 1,
    'es-ES' = 2,
}

export default Languages;
